import React from 'react';
import { Button, Col, Form, InputNumber, notification, PageHeader, Row } from 'antd';
import {
  useBack,
  useHandleSubmit,
  useFirestore,
  useAuth,
  L10nField,
} from '@betwyll/btw-core-backoffice';
import { useAsync } from 'react-async';
import { useTranslation } from 'react-i18next';
import { LANGUAGES } from '../../constants';

const formLayout = {
  layout: 'horizontal',
  labelCol: { span: 3 },
  wrapperCol: { span: 10 },
};

function CreateForm({ form, onSubmit, loading }) {
  const { getFieldDecorator } = form;

  const { t } = useTranslation('materials');

  const handleSubmit = useHandleSubmit({ form, handler: onSubmit });

  return (
    <Form onSubmit={handleSubmit} {...formLayout}>
      <Form.Item label={t('index')} extra={t('title_hint')}>
        {getFieldDecorator('index', {
          rules: [
            {
              required: true,
            },
          ],
        })(<InputNumber />)}
      </Form.Item>
      <Form.Item label={t('label')}>
        {getFieldDecorator('labelL10n', {
          rules: [
            {
              required: true,
            },
          ],
        })(<L10nField languages={LANGUAGES} />)}
      </Form.Item>
      <Row type="flex" justify="end">
        <Col span={4}>
          <Button type="primary" htmlType="submit" loading={loading}>
            {t('create')}
          </Button>
        </Col>
      </Row>
    </Form>
  );
}

const DidacticCategoryCreateForm = Form.create()(CreateForm);

async function createDidacticCategory([data, clean], { ref, onSuccess }) {
  try {
    await ref.set(data);
    clean();
    onSuccess();
  } catch (e) {
    notification.error({ message: e.message });
  }
}

export default function DidacticSetsCreate() {
  const onBack = useBack();
  const firestore = useFirestore();
  const auth = useAuth();

  const ref = firestore()
    .collection('didacticCategories')
    .doc();

  const { run, isPending: creating } = useAsync({
    deferFn: createDidacticCategory,
    firestore,
    ref,
    auth,
    onSuccess: onBack,
  });

  const { t } = useTranslation('materials');

  return (
    <>
      <PageHeader title={t('new_didacticCategory')} onBack={onBack} />
      <DidacticCategoryCreateForm onSubmit={run} loading={creating} id={ref.id} />
    </>
  );
}
